module.exports = __webpack_public_path__ + "static/media/sidebar-5.8336c4e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-5.jpg
// module id = 608
// module chunks = 4